import React from 'react';
import './../index.css';
import { LevelNav } from './LevelNav';
import { LevelTitle } from './LevelTitle';

class SearchResult {
  index = '';
  levelTitle = '';
  constructor(index, levelTitle) {
    this.index = index;
    this.levelTitle = levelTitle;
  }
}


export class SearchResults extends React.Component {


  search(searchValue) {
    let searchResults = new Array();
    let lcSearchValue = searchValue.toLowerCase();
    this.props.map.forEach((value, key) => {
      if('1.1.10.3' === key) {
        console.log(key);
      }
      if (value.title && -1 !== value.title.toLowerCase().indexOf(lcSearchValue)) {
        let result = new SearchResult(key, value.title);
        this.addToResults(searchResults,result);
      }
      if(value.links) {
        value.links.forEach(link=>{
          if (link && -1 !== link.text.toLowerCase().indexOf(lcSearchValue)) {
            let result = new SearchResult(key, value.title);
            this.addToResults(searchResults,result);
          } 
        });
      }
      if(value.movies) {
        value.movies.forEach(movie=>{
          if (movie && -1 !== movie.text.toLowerCase().indexOf(lcSearchValue)) {
            let result = new SearchResult(key, value.title);
            this.addToResults(searchResults,result);
          } 
        });
      }
      if(value.books) {
        value.books.forEach(book=>{
          if (book && -1 !== book.text.toLowerCase().indexOf(lcSearchValue)) {
            let result = new SearchResult(key, value.title);
            this.addToResults(searchResults,result);
          } 
        });
      }
      if(value.videos) {
        value.videos.forEach(video=>{
          if (video && -1 !== video.text.toLowerCase().indexOf(lcSearchValue)) {
            let result = new SearchResult(key, value.title);
            this.addToResults(searchResults,result);
          } 
        });
      }
      if (value.text && -1 !== value.text.toLowerCase().indexOf(lcSearchValue)) {
        let result = new SearchResult(key, value.title);
        this.addToResults(searchResults,result);
      }
    });
    return searchResults;
  }

  addToResults(searchResults,result) {
    if(!searchResults.find(sr => sr.index === result.index)) {
      searchResults.push(result);
    }
  }

  searchClicked(index) {
    this.props.setSearchValue('');
    this.props.onLevelClick(index)
  }

  render() {
    const title = this.props.title;
    const results = this.search(this.props.searchValue)
    return (
      <>
        <LevelTitle
          title={title}
        />
        <LevelNav
          parentTitle={''}
          parentIndex={'0.'}
          onLevelClick={''}
          searchValue={this.props.searchValue}
          searchChange={(i) => this.props.searchChange(i)}
        />
        {
          <div className='searchResults'>
            <table style={{ width: "100%" }}><tbody>{
              results.map(
                currentResult =>
                  <tr key={currentResult.index}>
                    <td key={currentResult.index}>
                      <button className='searchResult' onClick={
                        () => this.searchClicked(currentResult.index)
                      }>
                        {currentResult.levelTitle}
                      </button>
                    </td>
                  </tr>
              )
            }</tbody></table>
          </div>
        }

      </>
    );
  }


}
